import { UseMutationResult } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';

export const deleteBookingUtils = (
    setIsDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setBookingToDelete: React.Dispatch<
        React.SetStateAction<QueueSheetManagementRows | null>
    >,
    bookingToDelete: QueueSheetManagementRows | null,
    deleteBookingMutation: UseMutationResult<ApiResponseKeys, ApiError, string>
) => {


    const handleDeleteClick = (booking: QueueSheetManagementRows) => {
        deleteBookingMutation.reset();
        setBookingToDelete(booking);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteCancel = () => {
        setIsDeleteModalOpen(false);
        setBookingToDelete(null);
    };

    const handleDeleteConfirm = () => {
        if (bookingToDelete?.bookingId != null)
            deleteBookingMutation.mutate(bookingToDelete.bookingId);
    };

    return {
        handleDeleteClick,
        handleDeleteCancel,
        handleDeleteConfirm,
        deleteBookingMutation,
    };
};
